import { Box, type SxProps, type Theme } from "@mui/material";
import type { FC, ReactElement, ReactNode } from "react";
import { EyebrowLabel } from "../../../../components/UIToolkit/molecules/EyebrowLabel";
import { LOCATION_STAFFING as S } from "../../../../theme/tokens";

type Props = {
	/** Already translated: "Target", "Census from". */
	label: string;
	/**
	 * The id of the text input the label names, so the input takes its name from it. Null when the control already
	 * names itself (a stepper's spinbutton carries its own `aria-label`): the label is then only what the eye reads.
	 */
	labelFor: string | null;
	children: ReactNode;
	/** Placement only: a grid area, a fixed width. */
	sx?: SxProps<Theme>;
};

/**
 * One field of the v2 staffing lines (a day group's Target and Required, a ladder step's census range and staff): the
 * house uppercase label over the control, as the design draws every field of the editor's staffing block.
 */
export const StaffingFieldV2: FC<Props> = ({ label, labelFor, children, sx }): ReactElement => (
	<Box sx={[{ display: "flex", flexDirection: "column", gap: `${S.FIELD_LABEL_GAP}px`, minWidth: 0 }, ...(Array.isArray(sx) ? sx : [sx])]}>
		{labelFor === null ? <EyebrowLabel ariaHidden>{label}</EyebrowLabel> : <EyebrowLabel htmlFor={labelFor}>{label}</EyebrowLabel>}
		{children}
	</Box>
);
